var ks = ks || {};

// section slider history
// -----------------------------------------------------------------

ks.sectionSlider = function () {
  var $sectionSlider = $(".js_sectionSlider").removeClass("visuallyhidden");

  if (!$sectionSlider.length) {
    return;
  }

  $(".js_sectionSlider").slick({
    autoplay: false,
    infinite: true,
    arrows: true,
    appendArrows: $(".gallery__navigation"),
    prevArrow: '<div class="slick-prev"><i class="icon-arrow-left"></i></div>',
    nextArrow: '<div class="slick-next"><i class="icon-arrow-right"></i></div>',
    dots: false,
    autoplay: true,
    speed: 1100,
    slidesToShow: 1,
    slidesToScroll: 1,
    responsive: [
      {
        breakpoint: 800,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
        },
      },
    ],
  });
};

// section slider green
// -----------------------------------------------------------------

ks.sectionSliderReversed = function () {
  var $sectionSliderReversed = $(".js_sectionSliderReversed").removeClass(
    "visuallyhidden"
  );

  if (!$sectionSliderReversed.length) {
    return;
  }

  $(".js_sectionSliderReversed").slick({
    autoplay: false,
    infinite: true,
    arrows: true,
    appendArrows: $(".gallery__navigation--reversed"),
    prevArrow: '<div class="slick-prev"><i class="icon-arrow-left"></i></div>',
    nextArrow: '<div class="slick-next"><i class="icon-arrow-right"></i></div>',
    dots: false,
    autoplay: true,
    speed: 1100,
    slidesToShow: 1,
    slidesToScroll: 1,
    responsive: [
      {
        breakpoint: 800,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
        },
      },
    ],
  });
};

// section future
// -----------------------------------------------------------------

ks.sectionSliderFuture = function () {
  var $sectionSliderFuture = $(".js_sectionSliderFuture").removeClass(
    "visuallyhidden"
  );

  if (!$sectionSliderFuture.length) {
    return;
  }

  $(".js_sectionSliderFuture").slick({
    autoplay: false,
    infinite: true,
    arrows: true,
    appendArrows: $(".gallery__navigation--future"),
    prevArrow: '<div class="slick-prev"><i class="icon-arrow-left"></i></div>',
    nextArrow: '<div class="slick-next"><i class="icon-arrow-right"></i></div>',
    dots: false,
    autoplay: true,
    speed: 1100,
    slidesToShow: 1,
    slidesToScroll: 1,
    responsive: [
      {
        breakpoint: 800,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
        },
      },
    ],
  });
};

$(document).ready(function () {
  ks.sectionSlider();
  ks.sectionSliderReversed();
  ks.sectionSliderFuture();
});
